import Navbar from "../../components/Navbar";
import "./css/itinerary.css"
import data from "../../data/ItineraryData"
import Footer from "../../components/Footer";

const Itinerary = () => {
    return (
        <main>
            <Navbar/>

            <div className="container itinerary__container">
                <div className="itinerary__header">
                    <h1 className="text-cursive">Wedding Day</h1>
                    <h3>June 20, 2026</h3>
                </div>

                <hr/>

                <div className="container itinerary__schedule">

                    {
                        data.map((i) => {
                            return (
                                <>
                                    <div className="itinerary__schedule-row">
                                        <div className="itinerary__schedule-col1">
                                            <h3>{i.time}</h3>
                                        </div>
                                        <div className="itinerary__schedule-col2">
                                            <h3>{i.title}</h3>
                                            {i.addressLine1 != null && <h4>{i.addressLine1}</h4>}
                                            {i.addressLine2 != null && <h4><i>{i.addressLine2}</i></h4>}
                                            {i.addressLine3 != null && <h4><i>{i.addressLine3}</i></h4>}
                                            {i.description != null && <h4>{i.description}</h4>}
                                        </div>
                                    </div>
                                    <hr/>
                                </>
                            )
                        })
                    }
                </div>
            </div>
            <Footer/>
        </main>
    );
};

export default Itinerary;